export default __webpack_public_path__ + "894b0cf29329d7bf54ef58786bb35465.svg";